export function formatPrice(value: string): string {
  const [integerPart, decimalPart] = value
    .replace(/[^0-9.]+/g, "")
    .replace(/^0{2,}/g, "0")
    .replace(/^0(?=\d)/g, "")
    .split(".");

  const hasDecimal = value.includes(".");
  const formatedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const formatedDecimalPart = hasDecimal ? `.${decimalPart ?? ""}` : "";

  if (hasDecimal && !integerPart) {
    return "0.";
  }

  return `${formatedIntegerPart}${formatedDecimalPart}`;
}
